import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const ASSET_NAME = 'contact_us_page';

export const loadData = (params, search) => dispatch => {
  const pageAsset = { contactUsPage: `content/pages/${ASSET_NAME}.json` };
  // The page renders fine without the hosted asset (defaultPageData in
  // ContactUsPage.js), so swallow rejections to avoid Sentry noise when the
  // asset is missing in Sharetribe Console.
  return dispatch(fetchPageAssets(pageAsset, true)).catch(() => null);
};
